export const TOKENS_PER_K = 1024;
const CONTEXT_2K = 2;
const CONTEXT_3K = 3;
const CONTEXT_4K = 4;
const CONTEXT_8K = 8;
const CONTEXT_16K = 16;
const CONTEXT_32K = 32;
export const getContextLimit = (k) => {
    return k * TOKENS_PER_K;
};
export var ContextSize;
(function (ContextSize) {
    ContextSize[ContextSize["SIZE_2K"] = getContextLimit(CONTEXT_2K)] = "SIZE_2K";
    ContextSize[ContextSize["SIZE_3K"] = getContextLimit(CONTEXT_3K)] = "SIZE_3K";
    ContextSize[ContextSize["SIZE_4K"] = getContextLimit(CONTEXT_4K)] = "SIZE_4K";
    ContextSize[ContextSize["SIZE_8K"] = getContextLimit(CONTEXT_8K)] = "SIZE_8K";
    ContextSize[ContextSize["SIZE_16K"] = getContextLimit(CONTEXT_16K)] = "SIZE_16K";
    ContextSize[ContextSize["SIZE_32K"] = getContextLimit(CONTEXT_32K)] = "SIZE_32K";
})(ContextSize || (ContextSize = {}));
const DEFAULT_MODEL_ID = "default";
const resolveTierLimitK = (permissions) => {
    const userContextLimitsK = permissions
        .map((perm) => {
        const match = perm.match(/^(\d+)k_context$/);
        return match?.[1] ? parseInt(match[1], 10) : null;
    })
        .filter((limit) => limit !== null);
    if (userContextLimitsK.length === 0) {
        return null;
    }
    return Math.max(...userContextLimitsK);
};
const resolveModelLimitK = ({ inferenceModels, inferenceModelId, }) => {
    const models = inferenceModels || [];
    const selectedModel = models.find((model) => model.id === inferenceModelId) ?? models.find((model) => model.id === DEFAULT_MODEL_ID);
    const modelK = selectedModel?.tokens ? parseInt(selectedModel.tokens, 10) : NaN;
    return isNaN(modelK) ? null : modelK;
};
export const getAvailableMemory = (permissions, inferenceModels, inferenceModelId) => {
    if (!permissions?.length)
        return ContextSize.SIZE_2K;
    const tierLimitK = resolveTierLimitK(permissions);
    if (tierLimitK === null) {
        return ContextSize.SIZE_2K;
    }
    const modelLimitK = resolveModelLimitK({ inferenceModels, inferenceModelId });
    if (modelLimitK === null) {
        return getContextLimit(tierLimitK);
    }
    return getContextLimit(Math.min(tierLimitK, modelLimitK));
};
